import React from 'react'

const Miplan = () => {
  return (
    <div>
        <div>
        <h2 className='md:text-[64px] md:leading-[81px] text-[32px] mb-5 font-bold leading-[37px]'>Mi plan</h2>
          <p className='md:text-[24px] text-[14px] font-normal text-[#ED0006]'>Aún no has contratado un plan, elige la opción que necesitas a continuación</p> 
        </div>
        <div>
        <div className='flex items-center mt-5 gap-9 sm:flex-row flex-col'>
                    <div className='p-[32px] w-full md:h-[320px] h-[199px] flex flex-col items-center gap-[10px] justify-center bg-white price_box hover:bg-[#4285F4] hover:text-white'>
                        <p className='text-center md:text-[24px] text-[14px] md:leading-[37px] leading-[16px]'>Análisis y regularización fiscal</p>
                        <h2 className='md:text-[64px] md:leading-[75px] text-[32px] leading-[37px] font-semibold'>$1000</h2>
                        <p className='text-center md:text-[24px] text-[14px] md:leading-[37px] leading-[16px]'>Por año no declarado</p>
                    </div>
                    <div className='p-[32px] w-full md:h-[320px] h-[199px]  flex flex-col items-center gap-[10px] justify-center bg-white price_box hover:bg-[#4285F4] hover:text-white'>
                        <p className='text-center md:text-[24px] text-[14px] md:leading-[37px] leading-[16px]'>Tu contabilidad transparente, fácil y en la palma de tu mano</p>
                        <h2 className='md:text-[64px] md:leading-[75px] text-[32px] leading-[37px] font-semibold'>$300 <span className='text-[14px] font-normal'>/Mes</span></h2>
                    </div>
                    </div>
        </div>
    </div>
  )
}

export default Miplan